import { styled } from '@mui/material';

export const Root = styled('div')({});

export const ChipWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  margin: -3,

  '& > *': {
    margin: 3,
  },
});

export const Dot = styled('div')({
  width: 18,
  height: 18,
  '&::before': {
    content: '""',
    borderRadius: '50%',
    width: 10,
    height: 10,
    margin: 4,
    display: 'block',
  },
});
